<template minapp='mpx' xlang='wxml'>
  <view class="scramble-info-wrap">
    <view class="info">
      <view class="name">{{ main_train_info.from_station_name }}</view>
      <image class="image" mode="widthFix" src="{{icon}}"></image>
      <view class="name">{{ main_train_info.to_station_name }}</view>
    </view>
    <view class="alternative">
      <view class="item">
        <view class="name">抢票车次</view>
        <view class="text-container">
          <view class="text" wx:for="{{alternative_train_codes}}">{{ item }}&nbsp;&nbsp;</view>
        </view>
      </view>
      <view class="item">
        <view class="name">抢票日期</view>
        <view class="text-container">
          <view class="text" wx:for="{{alternative_start_date}}">{{ item }}&nbsp;&nbsp;</view>
        </view>
      </view>
      <view class="item">
        <view class="name">抢票坐席</view>
        <view class="text-container">
          <view class="text" wx:for="{{alternative_seat_code}}"
            >{{ item.seat_name }}&nbsp;&nbsp;</view
          >
        </view>
      </view>
      <view wx:if="{{scrambling}}" class="item">
        <view class="name">截止时间</view>
        <view class="text-container">
          <view class="text">{{ dead_line_hour_text }}</view>
        </view>
      </view>
      <view class="item">
        <view class="name">乘车人</view>
        <view class="text-container">
          <view class="text" wx:for="{{passengers}}" wx:key="index">
            <image
              class="icon"
              mode="widthFix"
              src="https://ut-static.udache.com/webx/sfc/dNjyVmQgbR_WI8ZW2Fey9_clipboard_image_1697776600527.png"
            ></image
            >{{ item }}&nbsp;&nbsp;</view
          >
        </view>
      </view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { innerRouter, pagePath } from '@/common/jump'
  import store from '@/store'
  import { formatDate } from '@/utils/baseDate'
  import { DeadLineList } from "@/utils/constants";

  createComponent({
    props: {
      scrambling: {
        type: Boolean,
        value: false,
      }
    },
    data:{
      icon:"https://ut-static.udache.com/webx/sfc/SHWz0Wt6vDHo8rOzKTpVY_clipboard_image_1697777143756.png",
    },
    computed: {
      ...store.mapState({
        scramble_ticket_info: 'order.scramble_ticket_info'
      }),
      main_train_info(){
        return this.scramble_ticket_info?.main_train_info
      },
      alternative_train_codes(){
        return this.scramble_ticket_info?.alternative_train_codes
      },
      alternative_start_date(){
        return this.scramble_ticket_info?.alternative_start_date?.map(_d => formatDate(_d, 'MM月dd日'))
      },
      alternative_seat_code(){
        return this.scramble_ticket_info?.alternative_seat_code
      },
      passengers() {
        return this.scramble_ticket_info?.passengers?.map(({passenger_name}) => passenger_name)
      },
      dead_line_hour_text(){
        let res=  DeadLineList.find((item)=>{
          return item.hour == this.scramble_ticket_info?.dead_line_hour
        })
        return res?.text
      }
    },
    methods: {
    }
  })
</script>
<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'

  .scramble-info-wrap
    border-radius 8px
    background #FFFFFF
    padding-bottom 20px
    margin-bottom 8px
    margin-top 8px
    .info
      margin 0 14px
      padding 16px 0
      border-bottom 0.5px #f0f1f4 solid
      display flex
      align-items center
      .name
        font-family PingFangSC-Semibold
        font-size 16px
        font-weight normal
        line-height 1
        color #333
      .image
        width 16px
        margin 0 6px
    .alternative
      .item
        display flex
        align-items flex-start
        margin-top 15px
        font-family PingFangSC-Regular
        font-size 14px
        font-weight normal
        line-height 1
        letter-spacing 0
        &:first-child
          margin-top 17px
        .name
          flex-shrink 0
          color #999
          margin-left 14px
          margin-right 14px
          display inline-block
          width 58px
        .text-container
          flex 1
          padding-right 11px
          display flex
          align-items center
          flex-wrap wrap
          color #000000
          .text
            margin-bottom 6px
          .icon
            width 10px
            margin-right 4px
        .text-gray
          color #999
</style>
<script name='json'>
  module.exports = {
    component: true
  }
</script>